import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames';
import {
  Paper,
  PaperContent,
  PaperHeadline,
  Option,
  Text,
  Button,
  Checkbox
} from '../../'
import classNames from 'classnames'

export class MakePaymentCard extends React.PureComponent {
  static propTypes = {
    caption: PropTypes.string,

    errorMessage: PropTypes.string,
    existingCardOptions: PropTypes.arrayOf(
      PropTypes.shape({
        active: PropTypes.bool,
        onClick: PropTypes.func,
        description: PropTypes.string
      })
    ),
    payWithDifferentCardOption: PropTypes.shape({
      active: PropTypes.bool,
      hidden: PropTypes.bool,
      onClick: PropTypes.func
    }),
    annualCheckboxProps: PropTypes.shape({
      showCheckbox: PropTypes.bool,
      checked: PropTypes.bool,
      onChange: PropTypes.func,
      name: PropTypes.string,
      value: PropTypes.string,
      id: PropTypes.string
    }),
    combinedProductCheckboxProps: PropTypes.shape({
      showCheckbox: PropTypes.bool,
      checked: PropTypes.bool,
      onChange: PropTypes.func,
      name: PropTypes.string,
      value: PropTypes.string,
      id: PropTypes.string
    }),
    petMedAlertCheckboxProps: PropTypes.shape({
      showCheckbox: PropTypes.bool,
      checked: PropTypes.bool,
      onChange: PropTypes.func,
      name: PropTypes.string,
      value: PropTypes.string,
      id: PropTypes.string
    }),
    vetHelplineCheckboxProps: PropTypes.shape({
      showCheckbox: PropTypes.bool,
      checked: PropTypes.bool,
      onChange: PropTypes.func,
      name: PropTypes.string,
      value: PropTypes.string,
      id: PropTypes.string
    }),
    petcademyCheckboxProps: PropTypes.shape({
      showCheckbox: PropTypes.bool,
      checked: PropTypes.bool,
      onChange: PropTypes.func,
      name: PropTypes.string,
      value: PropTypes.string,
      id: PropTypes.string
    }),
    directConnectCheckboxProps: PropTypes.shape({
      showCheckbox: PropTypes.bool,
      checked: PropTypes.bool,
      onChange: PropTypes.func,
      name: PropTypes.string,
      value: PropTypes.string,
      id: PropTypes.string
    }),
    pumpkinWellnessCheckboxProps: PropTypes.shape({
      showCheckbox: PropTypes.bool,
      checked: PropTypes.bool,
      onChange: PropTypes.func,
      name: PropTypes.string,
      value: PropTypes.string,
      id: PropTypes.string
    }),
    continueButtonProp: PropTypes.shape({
      id: PropTypes.string,
      label: PropTypes.string,
      onClick: PropTypes.func
    }),
    id: PropTypes.string,
    className: PropTypes.string,
    style: PropTypes.object,
    refProp: PropTypes.oneOfType([
      PropTypes.func,
      PropTypes.shape({ current: PropTypes.instanceOf(Element) })
    ])
  }

  static defaultProps = {
    caption: 'Do you want to make a payment with your saved card?',
    existingCardOptions: [],
    payWithExistingCardOption: {},
    payWithDifferentCardOption: {}
  }

  render() {
    const {
      caption,
      errorMessage,
      existingCardOptions,
      payWithDifferentCardOption,
      annualCheckboxProps,
      petMedAlertCheckboxProps,
      combinedProductCheckboxProps,
      vetHelplineCheckboxProps,
      directConnectCheckboxProps,
      petcademyCheckboxProps,
      continueButtonProp,
      pumpkinWellnessCheckboxProps,
      id,
      className,
      style,
      refProp
    } = this.props

    return (
      <Paper
        type={Paper.Types.framed}
        id={id}
        className={cn('ui-make-a-payment-card', className)}
        style={style}
        ref={refProp}
      >
        <PaperHeadline>Make a Payment</PaperHeadline>

        <PaperContent className='ui-make-a-payment-card__content'>
          <Text type={Text.Types.caption}>{caption}</Text>

          {errorMessage && (
            <Text
              type={Text.Types.bodyBold}
              className='ui-make-a-payment-card__error-message'
            >
              {errorMessage}
            </Text>
          )}

          <div className='ui-make-a-payment-card__options'>
            {existingCardOptions.map(({ description, ...rest }) => (
              <Option
                key={`payment-option-${description}`}
                label={
                  <>
                    <span className='ui-make-a-payment-card__option__label--desktop'>
                      Pay with my saved credit card
                    </span>
                    <span className='ui-make-a-payment-card__option__label--mobile'>
                      Pay with card
                    </span>
                  </>
                }
                description={<Text>{description}</Text>}
                {...rest}
              />
            ))}

            {!payWithDifferentCardOption.hidden && (
              <Option
                label='Pay with a different card'
                {...payWithDifferentCardOption}
              />
            )}
          </div>
          <div className='ui-make-a-payment-card__checkboxes'>
            {combinedProductCheckboxProps.showCheckbox && (<Checkbox
              showPetplaceCheckbox={true}
              label="Turn on auto-renew for 24PetMedAlert® and 24/7 Vet Helpline subscription bundle one year from date of purchase for $19.95/year (plus tax). Don't worry - you can cancel anytime in your account dashboard."
              {...combinedProductCheckboxProps}
            />)}
            {pumpkinWellnessCheckboxProps.showCheckbox && (<Checkbox
              showPetplaceCheckbox={true}
              label="Turn on auto-renew for Pumpkin Wellness Club subscription one month from date of purchase for $19.95/month (plus tax). Don't worry - you can cancel anytime in your account dashboard."
              {...pumpkinWellnessCheckboxProps}
            />)}
            {directConnectCheckboxProps.showCheckbox && (<Checkbox
              showPetplaceCheckbox={true}
              label="Turn on auto-renew for DirectConnect one month from date of purchase for $4.95/month (plus tax). Don't worry - you can cancel anytime in your account dashboard."
              {...directConnectCheckboxProps}
            />)}
            {petMedAlertCheckboxProps.showCheckbox && (<Checkbox
              showPetplaceCheckbox={true}
              label="Turn on auto-renew for 24PetMedAlert one month from date of purchase for $4.95/month (plus tax). Don't worry - you can cancel anytime in your account dashboard."
              {...petMedAlertCheckboxProps}
            />)}
            {vetHelplineCheckboxProps.showCheckbox && (<Checkbox
              showPetplaceCheckbox={true}
              label="Turn on auto-renew for 24/7 Vet Helpline (whiskerDocs) one month from date of purchase for $4.95/month (plus tax). Don't worry - you can cancel anytime in your account dashboard."
              {...vetHelplineCheckboxProps}
            />)}
            {petcademyCheckboxProps.showCheckbox && (<Checkbox
              showPetplaceCheckbox={true}
              label="Turn on auto-renew for Petcademy one month from date of purchase for $12.95/month (plus tax). Don't worry - you can cancel anytime in your account dashboard."
              {...petcademyCheckboxProps}
            />)}
            {annualCheckboxProps.showCheckbox && (<Checkbox
              showPetplaceCheckbox={true}
              label="Turn on auto-renew for Annual Protection Membership one year from date of purchase for $19.95/year (plus tax). Don't worry - you can cancel anytime in your account dashboard."
              {...annualCheckboxProps}
              />)}
            </div>
          <Button
            className='ui-make-a-payment-card__action'
            color={Button.Colors.tertiary}
            {...continueButtonProp}
          >
            {continueButtonProp.label}
          </Button>
        </PaperContent>
      </Paper>
    )
  }
}
